import React, { ComponentType, useEffect, useMemo, useState } from 'react';
import { useStateContext } from '../../../hooks/useStateContext';
import api from '../../../services/api';
import { views } from '../../../schema/views';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import Item from './Item';
import { Header } from '../Header';

export const CheckManagement: ComponentType = () => {
  const { user } = useStateContext();

  const [required, setRequired] = useState<any>({});
  const [names, setNames] = useState<any>({});

  useEffect(() => {
    document.title = `Zoe - Required Fields`;
  }, []);

  function handleDebouncedOnChange(
    schema: any,
    column: string,
    checked: boolean
  ) {
    api.patch(`/required-fields`, {
      column: column,
      table: schema?.table,
      checked: checked,
    });
  }

  useEffect(() => {
    api.get(`/check-required-fields/${user.id}`).then((res: any) => {
      const names: any = {};
      Object.keys(views).map((viewName: any) => {
        names[`${viewName}`] = {};
        const view: any = views[`${viewName}` as keyof {}];
        Object.keys(view?.columns).map((item: any) => {
          names[`${viewName}`][`${item}`] = view?.columns[item]?.name;
        });
      });
      setNames(names);

      const mainViews: any = {};

      res.map((item: any) => {
        const fields: any = {};
        const req = item.check_required ? item.check_required : [];
        req.map((field: any) => {
          fields[`${field}`] = true;
        });

        mainViews[`${item?.table}`] = fields;
      });

      setRequired(mainViews);
    });
  }, []);

  const tables: any = useMemo(() => {
    return user.views;
  }, [user]);

  return (
    <>
      <Header
        title={'Check Required Fields'}
        subTitle={
          'Based on this, we check whether all data is filled in to close a weekend reservation.'
        }
      />

      <Box
        sx={{
          padding: '15px',
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        <Grid container spacing={'20px'}>
          {Object.keys(names).length ? (
            <>
              {tables.map((schema: any) => {

                if (!schema?.table || schema.table === 'crazy-groups'|| schema.table === 'crazy-bookings'){
                  return <></>;
                }

                const tableFields = required[`${schema?.table}`]
                  ? required[`${schema?.table}`]
                  : {};
                return (
                  <>
                    <Item
                      checkedFields={tableFields}
                      schema={schema}
                      names={names}
                      onCheck={(value) => {}}
                    />
                  </>
                );
              })}
            </>
          ) : (
            <></>
          )}
        </Grid>
      </Box>
    </>
  );
};
